module.exports = __webpack_public_path__ + "static/media/save.e76d0f92.svg";